/**
 * Blob ↔ ArrayBuffer / Uint8Array 変換ヘルパ。
 *
 * jsdom 等、`Blob.prototype.arrayBuffer()` が未実装な環境でも動くよう
 * FileReader にフォールバックする。
 */

export async function blobToUint8Array(blob: Blob): Promise<Uint8Array> {
  const buf = await blobToArrayBuffer(blob);
  return new Uint8Array(buf);
}

export async function blobToArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
  if (typeof blob.arrayBuffer === 'function') {
    try {
      const result = await blob.arrayBuffer();
      if (result instanceof ArrayBuffer) return result;
    } catch {
      /* fall through to FileReader */
    }
  }
  return new Promise<ArrayBuffer>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (): void => {
      const res = reader.result;
      if (res instanceof ArrayBuffer) {
        resolve(res);
      } else {
        reject(new Error('FileReader returned non-ArrayBuffer result'));
      }
    };
    reader.onerror = (): void => reject(reader.error ?? new Error('FileReader error'));
    // File をラップしないと jsdom で readAsArrayBuffer が失敗することがある
    const wrapped =
      typeof File !== 'undefined' && !(blob instanceof File)
        ? new File([blob], 'blob.bin', { type: blob.type })
        : blob;
    reader.readAsArrayBuffer(wrapped);
  });
}
